import "./DonorPartnerHub.module.css";
import Header from "@/reusable_sections/Header";
import PartnerOverview from "./sections/PartnerOverview";
import BenefitsOfPartnering from "./sections/BenefitsOfPartnering";
import BePartOfTheTransformation from "./sections/BePartOfTheTransformation";
import GiftsOfHope from "./sections/GiftsOfHope";
import Donate from "./sections/Donate";
import Footer from "@/reusable_sections/Footer";
export default function DonorPartnerHubPage() {
  return <div>
      <Header />
      <PartnerOverview />
      <BenefitsOfPartnering />
      <BePartOfTheTransformation />
      <GiftsOfHope />
      <Donate />
      <Footer />
    </div>;
}